import { Map, Record } from 'immutable'

const NotificationRecord = Record({
  id: null,
  type: null,
  createdAt: null,
  updatedAt: null,
  displayedAt: null,
  aknowledgedAt: null,
  metadata: Map(),
})
export default NotificationRecord

export function createFromRaw(rawNotification) {
  const { metadata, ...attributes } = rawNotification
  return new NotificationRecord(attributes).set('metadata', new Map(metadata))
}
